// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  //apiUrl: "https://api.packplan.co.uk",
 apiUrl: "https://newapi.packplan.net",
  firebase: {
    apiKey: "AIzaSyAi10WWAlThPShGuV92zFDuodUvlVlsWN0",
    authDomain: "packplan-5eda4.firebaseapp.com",
    databaseURL: "https://packplan-5eda4.firebaseio.com",
    projectId: "packplan-5eda4",
    storageBucket: "packplan-5eda4.appspot.com",
    messagingSenderId: "849210832014",
    appId: "1:849210832014:web:24a7ba93e5b200ef45c5df",
    measurementId: "G-ECKEB0XYK6"
  },
  CryptoJS: {
    key: '5056483776328765',
    iv: '5056483776328765',
    keySize: 128 / 8
  }
};
